import { Section } from '@factorialco/deprecated-design-system'

import helpCenterUrl from 'modules/core/lib/helpCenterUrl'
import i18n from 'modules/core/lib/i18n'

import ExpensesReimbursements from 'modules/compensations/pages/settings/ExpensesReimbursements'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const ExpensesReimbursementsPage = () => {
  return (
    <ResponsivePage.Body variant="full" showHeader={false}>
      <Section.FullWidth
        illustration="Replace"
        title={i18n.t('compensations.settings.expenses_reimbursements.spending_title')}
        description={i18n.t('compensations.settings.expenses_reimbursements.description')}
        link={{
          href: helpCenterUrl('payroll_additional_compensations'),
          label: i18n.t('compensations.settings.time_reimbursements.help_text'),
        }}
      >
        <ExpensesReimbursements />
      </Section.FullWidth>
    </ResponsivePage.Body>
  )
}

export default ExpensesReimbursementsPage
